import React from 'react';
import styled from 'styled-components';
import { useQuery, useMutation } from '@apollo/client';
import { If, Then, Else} from 'react-if';

const moment = require('moment-timezone').tz.setDefault('America/Mexico_City')
moment.locale('es');

// Models
import { STATS_ALL_TOURNAMENTS, STATS_GET_TOURNAMENT } from '../models/Stats';


import Loading from '../components/Loading';
import MatchDay from '../components/MatchDay';

// Assets
import ImgTxtRumboAlAtras from '../assets/ruboalastras/txtRumboAlAtras.png';

import ImgTextMomentosImportantes from '../assets/ruboalastras/txtMomentosImportantes.png';
import ImgTextLaPrevia from '../assets/ruboalastras/txtLaPrevia.png';
import ImgTextPromosActi from '../assets/ruboalastras/txtPromosActi.png';
import ImgTextInfoAdd from '../assets/ruboalastras/txtInfoAdd.png';

import ImgTextRedFanFest from '../assets/ruboalastras/txtRedFanFest.png';
import ImgTextRedPrevia from '../assets/ruboalastras/txtRedPrevia.png';
import ImgTextRedTerraza from '../assets/ruboalastras/txtRedTerraza.png';
import ImgTextRedWyngs from '../assets/ruboalastras/txtRedWyngs.png';

import ImgTextRedPromoAlim from '../assets/ruboalastras/txtRedPromoAlim.png';
import ImgTextRedMedio from '../assets/ruboalastras/txtRedMedio.png';
import ImgTextRedAfter from '../assets/ruboalastras/txtRedAfter.png';

import ImgIconAlimentoBeb from '../assets/ruboalastras/icoAlimentoBeb.png';
import ImgIconBoletos from '../assets/ruboalastras/icoBoletos.png';
import ImgIconFanId from '../assets/ruboalastras/icoFanId.png';
import ImgIconManual from '../assets/ruboalastras/icoManual.png';
import ImgIcoEstadio from '../assets/ruboalastras/icoEstadio.png';
import ImgIconProibido from '../assets/ruboalastras/icoProibido.png';
import ImgIconVenta from '../assets/ruboalastras/icoVenta.png';
import ImgIconEsta from '../assets/ruboalastras/icoEsta.png';

import ImgButacas from '../assets/ruboalastras/butacas.jpg';

const StyledPage = styled.main`
    .margin{
        max-width:800px;
        margin:auto;
        padding:50px 10px;
    }

    img{max-width:100%}

    .mainBox{
        display: flex;
        flex-direction: column;
        gap:10px;
    }
    h2{
        margin-top:40px;
        margin-bottom:0px;
    }
    .title{
        margin-top:40px;
        background-color: #282e5f;
        text-align: center;
        padding: 22px 18px;
        img{
            width: 400px;
        }
    }

    .cols2{grid-template-columns: repeat(2,1fr);}
    .cols3{grid-template-columns: repeat(3,1fr);}
    .cols4{grid-template-columns: repeat(4,1fr);}
    @media (max-width: 600px) {
        .cols3{grid-template-columns: repeat(2,1fr);}
        .cols4{grid-template-columns: repeat(2,1fr);}
    }
    @media (max-width: 400px) {
        .cols2{grid-template-columns: repeat(1,1fr);}
        .cols3{grid-template-columns: repeat(1,1fr);}
        .cols4{grid-template-columns: repeat(1,1fr);}
    }
    .box{
        display:grid;
        gap:15px;
        font-size:14px;
        
        .item{
            background-color: #fff;
            padding:0px 0px;
            h3{color:#fff;}
            > div{
                padding: 10px;
            }
        }
        h3{
            background-color: #e23e3c;
            text-align:center;
        }
        h5{
            font-size:16px;
            color:#000;
            margin:0px;
        }
        p{
            padding:5px;
            font-size:14px;
            margin:0px;
        }
    }
    .boxRed{
        h3{background-color: transparent}
        .item{
            color:#fff;

            padding:10px;
            background-color: var(--color-rojo);
            font-size: 30px;
            text-align: center;
            text-transform: uppercase;

            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
    }
    .addLinks{
        display: grid;
        gap:10px;
        a{
            display: flex;
            flex-direction: column-reverse;
            justify-content: center;
            align-items: center;
            &:hover{text-decoration:none}
            h5{
                text-align:center;
                font-size:15px;
                padding-top:5px;
                color:var(--color-primary);
            }
            img{
                width: 100px;
            }
        }
    }

`


if (!String.prototype.capitalize) {
  Object.defineProperty(String.prototype, 'capitalize', {
    value: function () {
      return this.charAt(0).toUpperCase() + this.slice(1);
    },
    configurable: true,
  });
}

export default  () => {

    const { loading:loadingListTournament, error:errorListTournament, data:dataListTournament } = useQuery(STATS_ALL_TOURNAMENTS,{
        variables:{
            'first':1,
            'page':0,
            'competicion_id':1,
            'active':true
        },
        context:{
            clientName:'SITE'
        }
    });

    const { loading:loadingTournament , error:errorTournament, data:dataTournament} = useQuery(STATS_GET_TOURNAMENT, {
        variables:{
            id:dataListTournament?.allTournaments?.data[0]?.id
        }, 
        context:{
            clientName:'SITE'
        },
        skip:dataListTournament?.allTournaments?.data[0]?.id===undefined 
    })

    if(loadingListTournament || loadingTournament)
        return <Loading />


    const listGamesLocal=dataTournament?.getTournament?.all_soccer_games?.filter( item => item.team_local?.id==50 || item.team_visitor?.id==50);
    const listGamesLocalOrder=listGamesLocal?.sort((a, b) => moment(a.fecha) - moment(b.fecha));

    const lastGame=listGamesLocalOrder?.findLast( item => !item.pendiente);
    const fechaPartdoPasado=lastGame?.fecha;

    const nextGame=listGamesLocalOrder?.find( item => item.pendiente);
    
    const hoursDiffPrevGame=moment().diff(fechaPartdoPasado, 'hours');
    const showResultPrevGame=hoursDiffPrevGame>=2 && hoursDiffPrevGame<=36;

    console.log('fechaPartdoPasado:',fechaPartdoPasado);
    console.log('nextGame:',nextGame);
    console.log('hoursDiffPrevGame:',hoursDiffPrevGame);
    console.log('showResultPrevGame:',showResultPrevGame);


    return (
        <StyledPage>
            <div className='title'><img src={ImgTxtRumboAlAtras} /></div>
            <div className='margin'>

                <div className='mainBox'>
                    <MatchDay 
                        showResultPrevGame={showResultPrevGame}
                        nextGame={nextGame}
                        lastGame={lastGame} 
                        / >
                            
                    <If condition={nextGame?.extras?.txt_prev?.replace(/<[^>]*>?/gm, '')}>
                        <Then>
                            <h2 className='header'><img src={ImgTextMomentosImportantes}/></h2>
                            <div className='box boxRed cols4'>
                                <div className='item'>
                                    <h3>Apertura de estacionamientos</h3>
                                    <div>{moment(nextGame?.extras?.date_open_park).format('HH:mm [HRS]')}</div>
                                </div>
                                <div className='item'>
                                    <h3>Apertura de puertas</h3>
                                    <div>{moment(nextGame?.extras?.date_open_doors).format('HH:mm [HRS]')}</div>
                                </div>
                                <div className='item'>
                                    <h3>Fin de<br /> promos</h3>
                                    <div>{moment(nextGame?.extras?.date_cupons_finish).format('HH:mm [HRS]')}</div>
                                </div>           
                                <div className='item'>
                                    <h3>Inicio de<br /> partido</h3>
                                    <div>{moment(nextGame?.extras?.date_game_start).format('HH:mm [HRS]')}</div>
                                </div>                     
                            </div>

                            <h2 className='header'><img src={ImgTextLaPrevia}/></h2>
                            <div className='box cols4'>
                                <div className='item'>
                                    <h3><img src={ImgTextRedFanFest} /></h3>
                                    <div>
                                        <div dangerouslySetInnerHTML={{__html: nextGame?.extras?.txt_fan_fest}}></div>
                                    </div>
                                </div>
                                <div className='item'>
                                    <h3><img src={ImgTextRedPrevia} /></h3>
                                    <div>
                                        <div dangerouslySetInnerHTML={{__html: nextGame?.extras?.txt_prev}}></div>
                                    </div>
                                </div>
                                <div className='item'>
                                    <h3><img src={ImgTextRedTerraza} /></h3>
                                    <div>
                                        <div dangerouslySetInnerHTML={{__html: nextGame?.extras?.txt_zone_floor}}></div>
                                    </div>
                                </div>           
                                <div className='item'>
                                    <h3><img src={ImgTextRedWyngs} /></h3>
                                    <div>
                                        <div dangerouslySetInnerHTML={{__html: nextGame?.extras?.txt_wingstop}}></div>
                                    </div>
                                </div>                     
                            </div>

                            <h2 className='header'><img src={ImgTextPromosActi}/></h2>
                            <div className='box cols2'>
                                <div className='item'>
                                    <h3><img src={ImgTextRedPromoAlim} /></h3>
                                    <div>
                                        <div dangerouslySetInnerHTML={{__html: nextGame?.extras?.txt_cupon_ayb}}></div>
                                    </div>
                                </div>
                                <div className='item'>
                                    <h3><img src={ImgTextRedMedio} /></h3>
                                    <div>
                                        <div dangerouslySetInnerHTML={{__html: nextGame?.extras?.txt_cupon_halftime}}></div>
                                    </div>
                        
                                </div>                
                            </div> 

                            <If condition={nextGame?.extras?.txt_after?.replace(/<[^>]*>?/gm, '')}>
                                <Then>
                                    <div className='box cols1'>
                                        <div className='item'>
                                            <h3><img src={ImgTextRedAfter} /></h3>
                                            <div>
                                                <div dangerouslySetInnerHTML={{__html: nextGame?.extras?.txt_after}}></div>
                                            </div>
                                        </div>              
                                    </div>
                                </Then>
                            </If>

                            <h2 className='header'><img src={ImgTextInfoAdd}/></h2>
                            <div className='addLinks cols4'>
                                <a href="https://storage.atleticodesanluis.mx/files/734_comida-y-bebidas_ap25.pdf" target="_blank" className='item'>
                                    <h5>Comida y bebida</h5>
                                    <div><img src={ImgIconAlimentoBeb} /></div>
                                </a>
                                <a href="https://storage.atleticodesanluis.mx/files/722_manual-del-aficionado_-ap25.pdf" target="_blank" className='item'>
                                    <h5>Manual del aficionado</h5>
                                    <div><img src={ImgIconManual} /></div>
                                </a>
                                <a href="https://storage.atleticodesanluis.mx/files/736_estacionamiento-ap25.pdf" target="_blank" className='item'>
                                    <h5>Estacionamientos</h5>
                                    <div><img src={ImgIconEsta} /></div>
                                </a>
                                <a href="https://storage.atleticodesanluis.mx/files/737_objetos-prohibidos-ap25.pdf" target="_blank" className='item'>
                                    <h5>Objectos prohibidos</h5>
                                    <div><img src={ImgIconProibido} /></div>
                                </a>
                                <a href="https://www.atleticodesanluis.mx/estadio" target="_blank" className='item'>
                                    <h5>Mapa del estadio</h5>
                                    <div><img src={ImgIcoEstadio} /></div>
                                </a>
                                <a href="https://storage.atleticodesanluis.mx/files/738_puntos-de-abonados-ap25.pdf" target="_blank" className='item'>
                                    <h5>Puntos de abonos</h5>
                                    <div><img src={ImgIconVenta} /></div>
                                </a>
                                <a href="https://storage.atleticodesanluis.mx/files/735_consulta-o-transferencia-de-boletos-ap25.pdf" target="_blank" className='item'>
                                    <h5>Consulta o trasferencia de boletos</h5>
                                    <div><img src={ImgIconBoletos} /></div>
                                </a>
                                <a href="https://fanliga.mx/es/" target="_blank" className='item'>
                                    <h5>Fan ID Liga MX</h5>
                                    <div><img src={ImgIconFanId} /></div>
                                </a>
                            </div>
                        
                        </Then>
                        <Else>
                            <div>
                                <img src={ImgButacas} />
                            </div>
                        </Else>
                    </If> 
                </div>
            </div>
        </StyledPage>
    )
}

